import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { NavController } from 'ionic-angular';

import { FullTextSearch } from '../../providers/rcs-connector-index-db/fulltextsearch';

@Component({
  selector: 'rcs-kd-job-search',
  templateUrl: 'rcs-kd-job-search.html'
})
export class RcsKdJobSearchComponent implements OnInit{

  @Output() search_term_emitter: EventEmitter<any> = new EventEmitter<any>();
  public search_term: string
  private visibility_optionsbar: boolean = false;

  constructor(public navCtrl: NavController) {}

  ngOnInit():void{}

  public submit(){
    let terms = new FullTextSearch().tokenize(this.search_term, 'en');
    this.search_term_emitter.emit(terms);

  }

  public clear():void{
    this.search_term_emitter.emit([]);
  }

  public set_visibility_optionsbar():void{
    if (this.visibility_optionsbar == false){
      this.visibility_optionsbar = true;
    }else{
      this.visibility_optionsbar = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/rcs-kd-job-search/rcs-kd-job-search.ts